import { Stack, Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import { PAGE_TWO_STYLES } from "../constants";
import { PageTwoFormData } from "../models";

const RequestField = ({ 
  label, 
  checkName, 
  textName, 
  control, 
  t 
}: { 
  label: string; 
  checkName: keyof PageTwoFormData; 
  textName: keyof PageTwoFormData; 
  control: any; 
  t: any;
}) => (
  <Stack direction="row" sx={{ paddingTop: "20px" }}>
    <Grid display="flex" flexDirection="row" sx={{ width: "100%", maxWidth: "300px" }}>
      <Controller
        name={checkName}
        control={control}
        render={({ field: { value, onChange } }) => (
          <ByzMuiCheckBox checked={!!value} onChange={onChange} />
        )}
      />
      <ByzMuiTypography sx={{ ...PAGE_TWO_STYLES.label, paddingRight: "20px" }}>
        {t(label)}
      </ByzMuiTypography>
    </Grid>
    <Grid sx={{ width: "100%", maxWidth: "300px" }}>
      <Controller
        name={textName}
        control={control}
        render={({ field }) => (
          <ByzMuiTextField
            {...field}
            multiline
            rows={2}
            sx={PAGE_TWO_STYLES.textField}
          />
        )}
      />
    </Grid>
  </Stack>
);

const PatientRequestsAndDischarge: React.FC = () => {
  const { t } = useTranslate();
  const { control } = useFormContext<PageTwoFormData>();

  return (
    <>
      <Grid sx={PAGE_TWO_STYLES.sectionTitle}>
        <ByzMuiTypography isTitle paddingTop="5px">
          {t("adult-patient-assessment.patient-requests-and-discharge-info")}
        </ByzMuiTypography>
      </Grid>
      
      <Grid container spacing={2} sx={{ padding: "0px", paddingTop: "20px" }}>
        <Grid md={6} xs={12} sx={PAGE_TWO_STYLES.gridItem}>
          <RequestField 
            label="adult-patient-assessment.has-religious-or-cultural-needs" 
            checkName="hasReligiousNeeds" 
            textName="religiousNeedsDetails" 
            control={control}
            t={t}
          />
          <RequestField 
            label="adult-patient-assessment.has-privacy-request" 
            checkName="hasPrivacyRequest" 
            textName="privacyRequestDetails" 
            control={control}
            t={t}
          />
        </Grid>
        
        <Grid md={6} xs={12} sx={PAGE_TWO_STYLES.gridItem}>
          <RequestField 
             label="adult-patient-assessment.special-covering-preference" 
             checkName="hasSpecialCoveringPref" 
             textName="coveringPrefDetails" 
             control={control}
             t={t}
          />
          <RequestField 
            label="adult-patient-assessment.special-clothing-preference" 
            checkName="hasSpecialClothingPref" 
            textName="clothingPrefDetails" 
            control={control}
            t={t}
          />
        </Grid>
      </Grid>

      <Divider sx={{ borderColor: "black", borderBottomWidth: "2px", my: 2 }} />

      <Stack direction="row" sx={{ padding: "0px", paddingTop: "10px" }} flexWrap="wrap">
        <Grid md={4} xs={12} sx={PAGE_TWO_STYLES.gridItem}>
           <ByzMuiTypography sx={{ ...PAGE_TWO_STYLES.label, height: "44px" }}>
            {t("adult-patient-assessment.needs-other-unit-consult-at-discharge")}
           </ByzMuiTypography>
           <Controller
            name="socialWorkConsultation"
            control={control}
            render={({ field }) => (
              <ByzMuiSelect
                {...field}
                options={[]}
                label={t("open-process-menu.select")}
                renderInput={(params: any) => <ByzMuiTextField {...params} />}
                sx={PAGE_TWO_STYLES.select}
              />
            )}
           />
        </Grid>
      </Stack>
    </>
  );
};

export default PatientRequestsAndDischarge;
